import * as React from 'react'
export const La = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#0052B4" d="M0 0h513v342H0z" />
    <path fill="#D80027" d="M0 .1h513v90.7H0zm0 251.2h513V342H0z" />
    <circle cx={256.5} cy={171} r={65.9} fill="#FFF" />
  </svg>
)
